// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2P6H8","gfeWrapper":"CalendarEvent_gfeWrapper__23Q3T"};